import { DefaultRequest } from 'scripts/api';

Greenmile.RouteDetail = Greenmile.RouteDetail || {};
Greenmile.RouteDetail.LineItems = Greenmile.RouteDetail.LineItems || {};
Greenmile.RouteDetail.LineItems.Grid = Greenmile.RouteDetail.LineItems.Grid || {};
/**
 * @constructor
 */
Greenmile.RouteDetail.LineItems.Grid = function (stopId, idScreen) {

  this.entity = 'RouteDetailsLineItem';
  this.containerGrid = `#lineItemsGrid_${stopId} #grid_${stopId}`;
  this.gridActionsSelector = `#lineItemsGrid_${stopId} .gridActions_${stopId}`;
  this.entityToActionGrid = 'RouteDetailsLineItem';
  this.countCustomColumns = 0;
  this.defaultFilters = {};

  this.show = function () {
    const options = {
      entity: this.entity,
      columnCheckBox: {
        show: false
      },
      selectorToGridActions: this.gridActionsSelector,
      entityToActionGrid: this.entityToActionGrid,
      gridContainner: this.containerGrid,
      columnEdit: {
        show: false
      },
      headerMenu: {
        headerMenuEventClass: Monet.Grid.ActionsModules.MenuShowTotals
      },
      multiColumnSort: true,
      rowHeight: 30
    };

    try {
      const router = new App.Routers[this.entity]();

      const filterBuilder = new Monet.UI.FilterBuilder();
      filterBuilder.setFieldsOverride({
        RATING: 'INTEGER',
        TEXT_AREA: 'TEXT'
      });

      const controlUpdate = new Monet.Grid.ControlUpdate();

      const executeFilter = () => {
        if (App.Forms.RouteSummaryRoutes && App.Forms.RouteSummaryRoutes.searchInProgress) {
          return;
        }

        Monet.Grid.Utils.clearPagination(this.entity);
        router.updateGrid(
          router.getFilter(stopId),
          Monet.Grid.addDataToGrid,
          true
        );
      };

      const afterSaveListCallback = function (context) {
        return function () {
          Monet.Grid.Utils.clearPagination(context.entity);
          App.Forms[context.entity].layout = {};

          const createdFilterBuilder = App.Forms[context.entity].filterBuilder;

          createdFilterBuilder.updateValuesSelectedFilters();
          createdFilterBuilder.saveState();

          context.show();
        };
      }(this);

      const afterAddSelectedField = ({ name, type }) => {
        if (name === 'order' && type === 'LOOKUP') {
          filterBuilder.fields.order.customCriteriaChain = [
            {
              attr: "stop.id",
              eq: stopId
            }
          ];
        }

      }

      const buildFilterBuilder = () => {
        filterBuilder.setEntity(this.entityToActionGrid);
        filterBuilder.setSelector(this.containerGrid);
        filterBuilder.setCustomNameSpace(this.entity);
        filterBuilder.setIdScreen(idScreen);
        filterBuilder.setAfterAddSelectedFilter(afterAddSelectedField);
        filterBuilder.setDefaultFilters(this.defaultFilters);
        filterBuilder.customRequest = executeFilter;
        filterBuilder.selectorContainerFilter = this.gridActionsSelector;
        filterBuilder.render();

        App.Forms[this.entity].filterBuilder = filterBuilder;

      };

      buildFilterBuilder();

      controlUpdate.setEntityToNamespace(this.entity);

      const customizeColumns = new Monet.Grid.ActionsModules.CustomizeColumns();
      const exportFormats = new Monet.Grid.ActionsModules.ExportFormats();
      const saveGridLayout = new Monet.Grid.ActionsModules.SaveGridLayout();

      const element = document.querySelector(this.gridActionsSelector);

      if (element) {
        element.innerHTML = '';
        element.appendChild(filterBuilder.el);
      }

      const monetUIGridActions = document.createElement("div");
      monetUIGridActions.setAttribute('class', "MonetUIGridActions");
      element.appendChild(monetUIGridActions);

      customizeColumns.setEntity(this.entityToActionGrid);
      customizeColumns.setScreenName(this.entity);
      customizeColumns.setSelector(this.gridActionsSelector);
      customizeColumns.setElement(monetUIGridActions);

      customizeColumns.setCallBacks({
        afterSaveList: afterSaveListCallback
      });

      exportFormats.setEntity(this.entityToActionGrid);
      exportFormats.setScreenName(this.entity);
      exportFormats.setSelector(this.gridActionsSelector);
      exportFormats.setElement(monetUIGridActions);
      exportFormats.getDataBeforeExportFormats = () => {
        const { sort } = router.getFilter(stopId);

        const lineItemsIds = App.Forms[this.entity].dataProvider.data
          .map(lineItem => lineItem.model.attributes.id)
          .map(id => parseInt(id));

        const parsedLineItemsIds = [...new Set(lineItemsIds)];

        return {
          filterSort: sort,
          filterCriteriaChain: {
            criteriaChain: [
              {
                and: [
                  {
                    attr: "id",
                    in: parsedLineItemsIds
                  }
                ]
              }
            ]
          },
          entityToRequest: 'LineItem',
        }
      };
      exportFormats.retrieveAllColumnsFromEntity = function (callbackLineItem) {
        const that = this;

        const request = new DefaultRequest({
          url: `form/${that.entity}/Fields`,
          success: function (data) {
            callbackLineItem(data, that.entity, that.selector, that.screenName);
          }
        });
        request.send();
      };

      const beforeSaveFieldList = () => {
        const lineItemsData = App.Forms[this.entity].dataProvider.data;

        if (!lineItemsData.length) {
          exportFormats.inProgress = false;
          exportFormats.togglePopUp();

          return false;
        }

        return true;
      };

      exportFormats.setCallBacks({
        beforeSaveFieldList
      });

      saveGridLayout.setEntity(this.entityToActionGrid);
      saveGridLayout.setScreenName(this.entity);
      saveGridLayout.setSelector(this.gridActionsSelector);
      saveGridLayout.setElement(monetUIGridActions);

      saveGridLayout.setCallBacks({
        afterSaveList: afterSaveListCallback
      });

      exportFormats.init();
      customizeColumns.init();
      saveGridLayout.init();

      filterBuilder.postRender();

      this.getColumns(function (columnsLoaded) {
        let columns = columnsLoaded || Monet.Grid.getGridLayout(App.Forms[this.entity].layout.index, this.entity);

        options.frozenColumn = -1;

        const dataView = new Monet.Grid.DataProvider(columns, null, this.entity);
        const grid = new Monet.Grid.GenericGrid(this.containerGrid, dataView, columns, options);

        const columnDefault = App.Forms[this.entity].columnToOrders;
        let columnSortDefault = [];

        if (columnDefault) {
          const sizeColumnDefault = columnDefault.length;

          for (let i = 0; i < sizeColumnDefault; i++) {
            const columnToSort = grid.getColumnByFieldName(columnDefault[i].field);
            const sort = columnDefault[i].order === 'ASC';

            if (columnToSort) {
              columnSortDefault.push({ columnId: columnToSort.id, sortAsc: sort });
            }
          }

          if (columnSortDefault.length) {
            grid.setSortColumns(columnSortDefault);
          }
        }

        App.Forms[this.entity].table = grid;
        App.Forms[this.entity].dataProvider = dataView;
        App.Forms[this.entity].controlUpdater = controlUpdate;

        executeFilter();

        if (this.afterShow) {
          this.afterShow();
        }
      }.bind(this));

    } catch (e) {
      new Monet.Exception.ReturnError(this, 'Error on show grid on route monitoring.', e).console();
    }

  };

  this.getColumns = function (callback) {
    try {
      if (!App.Forms[this.entity].layout) {
        App.Forms[this.entity].layout = {};
      }

      if (!App.Forms[this.entity].layout.index) {
        const route = new App.Routers[this.entity]();
        route.getFieldsToGridLayout(callback);
      } else {
        callback();
      }

    } catch (e) {
      new Monet.Exception.ReturnError(this,
        'Error on get  columns to ' + this.entity + ' on route monitoring.', e).console();
    }

  };

  this.init = function () {
    const dataMapper = new Monet.Builder.DataMapper();

    const filterBuiderInstance = App.Forms[this.entity]?.filterBuilder;

    if (filterBuiderInstance) {
      Object.keys(filterBuiderInstance.fields).forEach(field => {
        this.defaultFilters[field] = {};
      });

      filterBuiderInstance.clearFiltersToNamespace(this.entity);
    }

    const callback = () => {
      dataMapper.copyDataMapperToAnotherNamespace(this.entity);
      this.show();
    };

    dataMapper.setEntity(this.entityToActionGrid);
    dataMapper.build(callback);
  }

  return this;

};

